import React from 'react';

const Offers = ({ 
  offers, 
  loadingOffers, 
  setShowAddOfferModal, 
  handleDeleteOffer,
  handleEditOffer,
  setShowEditOfferModal,
  setSelectedOffer
}) => {
  return (
    <div>
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-xl font-semibold text-abiu-green-dark">My Offers</h2>
        <button
          onClick={() => setShowAddOfferModal(true)}
          className="bg-abiu-green text-white px-4 py-2 rounded-lg font-semibold hover:bg-abiu-green-dark transition"
        >
          + Add New Offer
        </button>
      </div>
      
      {loadingOffers ? (
        <div className="flex items-center justify-center py-8">
          <div className="w-8 h-8 border-4 border-abiu-green border-t-transparent rounded-full animate-spin"></div>
          <span className="ml-3 text-gray-600">Loading offers...</span>
        </div>
      ) : offers.length === 0 ? (
        <div className="text-center py-8">
          <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <svg className="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
            </svg>
          </div>
          <h3 className="text-lg font-semibold text-gray-900 mb-2">No Offers Yet</h3>
          <p className="text-gray-600 mb-4">Start by adding your first product or service offer.</p>
          <button
            onClick={() => setShowAddOfferModal(true)}
            className="bg-abiu-green text-white px-6 py-2 rounded-lg font-semibold hover:bg-abiu-green-dark transition"
          >
            Add Your First Offer
          </button>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {offers.map((offer) => (
            <div key={offer.id} className="border border-gray-200 rounded-lg p-4">
              <div className="flex justify-between items-start mb-3">
                <div className="flex-1">
                  <h3 className="font-semibold text-gray-900 mb-1">{offer.title}</h3>
                  <p className="text-sm text-gray-600 mb-2">{offer.description}</p>
                  <div className="flex items-center gap-4 text-xs text-gray-500">
                    <span>📍 {offer.location}</span>
                    <span>💰 {offer.price}</span>
                  </div>
                  {offer.images && offer.images.length > 0 && (
                    <div className="mt-2 flex gap-1">
                      {offer.images.slice(0, 3).map((image, index) => (
                        <img
                          key={index}
                          src={image}
                          alt={`Offer ${index + 1}`}
                          className="w-8 h-8 object-cover rounded"
                        />
                      ))}
                      {offer.images.length > 3 && (
                        <div className="w-8 h-8 bg-gray-200 rounded flex items-center justify-center text-xs text-gray-500">
                          +{offer.images.length - 3}
                        </div>
                      )}
                    </div>
                  )}
                </div>
                                        <div className="flex gap-1">
                          <button
                            onClick={() => {
                              setSelectedOffer(offer);
                              setShowEditOfferModal(true);
                            }}
                            className="text-blue-500 hover:text-blue-700 p-1"
                            title="Edit offer"
                          >
                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                            </svg>
                          </button>
                          <button
                            onClick={() => handleDeleteOffer(offer.id)}
                            className="text-red-500 hover:text-red-700 p-1"
                            title="Delete offer"
                          >
                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                            </svg>
                          </button>
                        </div>
              </div>
              <div className="flex items-center justify-between text-xs">
                <span className={`px-2 py-1 rounded-full ${
                  offer.status === 'Open' ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-600'
                }`}>
                  {offer.status}
                </span>
                <span className="text-gray-500">
                  {new Date(offer.createdAt).toLocaleDateString()}
                </span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Offers; 